export default __webpack_public_path__ + "static/media/firefox-gift.74d9aad1.gif";